import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const quotationApi = createApi({
  reducerPath: "quotationApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API,
    prepareHeaders: (headers, { extra }) => {
      if (extra?.skipAuth) {
        return headers;
      }
      const user = localStorage.getItem("hthUser");
      const token = user ? JSON.parse(user).token : null;
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getQuoteList: builder.query({
      query: ({ currentPage, status, userId }) => `/api/staff/getquotes/${userId}/${status}/${currentPage}/10`,
    }),
    addQuote: builder.mutation({
      query: (data) => ({
        url: `/api/staff/addQuote`,
        method: "POST",
        body: data,
      }),
    }),
    rejectLead: builder.mutation({
      query: (id) => ({
        url: `/api/staff/reject-lead/${id}`,
        method: "PUT",
      }),
    }),
    getViewComments: builder.query({
      query: (id) => `/api/staff/view-comments/${id}`,
    }),
    addComments: builder.mutation({
      query: (newHotelData) => ({
        url: `/api/staff/comments/add`,
        method: "POST",
        body: newHotelData,
      }),
    }),
    getAllLinks: builder.query({
      query: (id) => `/api/staff/getLinks/${id}`,
    }),
    getQuotePDF: builder.query({
      query: (id) => ({
        url: `/api/tour/quotation/${id}`,
        extraOptions: { skipAuth: true },
      }),
    }),
    getQuoteSearch: builder.query({
      query: (searchkey) => `/api/staff/searchQuotation/${searchkey}`,
    }),
    getPreFilledUserData: builder.query({
      query: (quoteId) => `/api/staff/getRegisterquotes/${quoteId}`,
    }),
    sendQuote: builder.mutation({
      query: (quoteData) => ({
        url: `/api/staff/sendQuote`,
        method: "POST",
        body: quoteData,
      }),
    }),
    getDefaultService: builder.query({
      query: () => `/api/staff/getServiceInfo`,
    }),
    getItenaryData: builder.query({
      query: () => `/api/staff/getAllItineraryList`,
    }),
    getSeachHotelPlace: builder.query({
      query: ({ searchkey, category }) => `/api/staff/getHotel/${searchkey}/${category}`,
    }),
    getSeachHotelCategory: builder.query({
      query: ({ searchkey, category }) => `/api/staff/getHotel/${searchkey}/${category}`,
    }),
    qRUpload: builder.mutation({
      query: (qrDetails) => ({
        url: `/api/staff/addQR`,
        method: "POST",
        body: qrDetails,
      }),
    }),
  }),
});

export const {
  useGetQuoteListQuery,
  useAddQuoteMutation,
  useRejectLeadMutation,
  useGetViewCommentsQuery,
  useAddCommentsMutation,
  useGetAllLinksQuery,
  useLazyGetQuotePDFQuery,
  useLazyGetQuoteSearchQuery,
  useGetPreFilledUserDataQuery,
  useSendQuoteMutation,
  useGetDefaultServiceQuery,
  useGetItenaryDataQuery,
  useGetSeachHotelPlaceQuery,
  useGetSeachHotelCategoryQuery,
  useQRUploadMutation,
} = quotationApi;
